/**
 * Single source of truth for the Talabatk brand colors.
 *
 * To rebrand the dashboard, change the values here (JS usage) and the matching
 * `--brand*` custom properties in `src/index.scss` (CSS/SCSS usage). Nothing
 * else should hardcode these hex values.
 */
export const BRAND = "#E65E0D"; // primary brand orange
export const BRAND_LIGHT = "#F5944D"; // lighter tint (gradients, hovers, focus)
export const BRAND_DARK = "#7A3208"; // darker shade (selected/active states)
